import type { UserInputField, FormContext, StepContext } from '../types'
import { TrackingEvent } from '../types'

export interface FieldSelectedArgs {
  formContext: FormContext
  stepContext: StepContext
  userInputField: UserInputField
}

export interface FieldSelectedProperties {
  formContext: FormContext
  stepContext: StepContext
  userInputField: UserInputField
}

export class FieldSelected extends TrackingEvent {
  properties: FieldSelectedProperties

  constructor(args: FieldSelectedArgs) {
    const {
      formContext = {
        formName: '',
        formType: '',
        formId: '',
      },
      stepContext = {
        stepName: '',
        stepId: '',
        stepNumber: 0,
      },
      userInputField = {
        fieldName: '',
        fieldType: '',
        fieldValue: '',
        fieldSource: '',
        autofilled: false,
      },
    } = args ?? {}

    super('FieldSelected', 'redventures.usertracking.v3.FieldSelected')

    this.properties = {
      formContext: {
        formName: formContext.formName,
        formType: formContext.formType,
        formId: formContext.formId,
      },
      stepContext: {
        stepName: stepContext.stepName,
        stepId: stepContext.stepId,
        stepNumber: stepContext.stepNumber,
      },
      userInputField: {
        fieldName: userInputField.fieldName ?? '',
        fieldType: userInputField.fieldType ?? '',
        fieldValue: userInputField.fieldValue ?? '',
        fieldSource: userInputField.fieldSource ?? '',
        autofilled: userInputField.autofilled ?? false,
      },
    }
  }
}
